import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useSEO } from "../lib/useSEO";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  useSEO({ title: "Log In", description: "Sign in to your Kootenay Home Pros account to manage your contractor profile or homeowner projects." });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-5 py-20">
      <div className="bg-white border border-[#E2DCD0] rounded-xl p-8 shadow-sm">
        <h1 className="text-3xl font-bold mb-2 tracking-tight" style={{ fontFamily: "Outfit" }}>Welcome back</h1>
        <p className="text-sm text-stone-600 mb-8">Sign in to your Kootenay Home Pros account.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input data-testid="login-email-input" id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="pw">Password</Label>
            <Input data-testid="login-password-input" id="pw" type="password" required value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full bg-[#314A3E] hover:bg-[#243a30] text-white">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <div className="my-6 flex items-center gap-3 text-xs text-stone-400">
          <div className="flex-1 h-px bg-[#E2DCD0]" /> OR <div className="flex-1 h-px bg-[#E2DCD0]" />
        </div>

        <Button data-testid="login-google-btn" onClick={googleLogin} variant="outline" className="w-full border-[#E2DCD0]">
          Continue with Google
        </Button>

        <p className="text-sm text-center mt-6 text-stone-600">
          No account? <Link to="/signup" className="text-[#B85C47] font-semibold">Create one</Link>
        </p>
      </div>
    </div>
  );
}
